import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProviders } from './app/providers/AppProviders.jsx';
import { AppRouter } from './app/AppRouter.jsx';
import './styles/global.css';
import './styles/catalog.css';
import './styles/hero.css';
import './styles/avod.css';
import './styles/filmmaker.css';
import './styles/subscriber-campaign-menu.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </React.StrictMode>,
);
